import { Box, Pagination } from "@mui/material";
import IPagination from "./interface/iPagination";
import React from "react";

const CustomPagination = ({
  items,
  paginationSettings,
  setPaginationSettings,
}: {
  items: any[];
  paginationSettings: IPagination;
  setPaginationSettings: React.Dispatch<React.SetStateAction<IPagination>>;
}): React.JSX.Element => (
  <React.Fragment>
    {items.length > paginationSettings.rowsPerPage && (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 2,
          mb: 5,
        }}
      >
        <Pagination
          count={Math.ceil(items.length / paginationSettings.rowsPerPage)}
          variant="outlined"
          shape="rounded"
          color="primary"
          sx={{
            "& .MuiPaginationItem-root": {
              borderRadius: 2,
            },
            "& .Mui-selected": {
              backgroundColor: (theme) => theme.palette.primary.main,
              color: (theme) => theme.palette.common.white,
            },
          }}
          page={paginationSettings.page}
          onChange={(_event, value) => {
            setPaginationSettings((prev: any) => ({
              ...prev,
              page: value,
            }));
          }}
        />
      </Box>
    )}
  </React.Fragment>
);

export default CustomPagination;
